import {mapActions, mapGetters} from "vuex";

export default {
    computed: {
        ...mapGetters(['getUser'])
    },
    data() {
        return {
            modalText: '',
            browser: {
                type: 0,
                device: 0
            },
        }
    },
    methods: {
        ...mapActions(['fetchToken', 'fetchUser', 'pushLocation', 'pushBrowser']),
        login() {
            this.isLoading = true;

            this.fetchToken(this.modelForm)
                .then(() => {
                    this.fetchUser()
                        .then(() => {
                            this.fetchLocation()
                            this.fetchBrowser()
                            this.modelForm.password = ''
                            this.$bvModal.hide('login')
                            this.$i18nHelper.toUrl('')
                            this.flashSuccess(this.$t('login.success', {login: this.getUser.person.givenName}));
                        })
                        .catch((reason) => {
                            this.modalText = reason;
                            this.$bvModal.show('modal_show');
                        })
                        .finally(()=> {
                            this.isLoading = false;
                        })
                })
                .catch((reason) => {
                    if (reason === 'connectionRefused') {
                        this.modalText = this.$t('connectionRefused')
                        this.$bvModal.show('modal_show')
                    } else {
                        this.modalText = this.$t('login.error');
                        this.$bvModal.show('modal_show')
                    }

                    this.isLoading = false;
                })
        },
        fetchLocation() {
            fetch('https://get.geojs.io/v1/ip/geo.json')
                .then((res) => res.json())
                .then((res) => {
                    this.pushLocation({city: res.city})
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        fetchBrowser() {
            const userAgent = navigator.userAgent;

            let browsers = {
                Chrome: 1,
                Explorer: 2,
                Safari: 3,
                Opera: 4,
                Firefox: 5,
                Other: 6
            };

            let browserType = Object.keys(browsers).find(browser => userAgent.indexOf(browser) > -1);
            this.browser.type = browserType ? parseInt(browsers[browserType]) : 1;
            this.browser.device = /Mobi|Android/i.test(userAgent) ? 10 : 20;
            this.pushBrowser(this.browser)
        }
    }
}
